var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Component, Schema } from "../../decorators/type.js";
import { registerSystem, DEPTHS } from "../ComponentRegistry.js";
import { L as LocomotionSchema } from "../../Locomotion-379972de.js";
import "../types.js";
import { T as TransformSchema } from "../../Transform-9450b7b5.js";
import { A as AttachSchema } from "../../Attach-abbbd93e.js";
import { A as AttachedSchema } from "../../Attached-c11af1dc.js";
import { C as ComponentCategory } from "../../enums-86f58524.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../global-33d5eebf.js";
import "../../utils/byteArray.js";
import "../../utils/vector.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let AttachPostSchema = class extends Schema {
};
AttachPostSchema = __decorateClass([
  Component("AttachPost")
], AttachPostSchema);
class AttachSystem {
  constructor() {
    __publicField(this, "type", "Attach");
    __publicField(this, "category", ComponentCategory.BEHAVIOR);
    __publicField(this, "schema", AttachSchema);
    __publicField(this, "depth", DEPTHS.LOCOMOTION + 10);
    __publicField(this, "dependencies", ["Owner", "Transform", "Locomotion"]);
  }
  init(entity, gameModel) {
    if (!gameModel.hasComponent(entity, "AttachPost")) {
      gameModel.addComponent(entity, "AttachPost");
    }
    const AttachData = gameModel.getTypedUnsafe(entity, AttachSchema);
    if (AttachData.parent == void 0 && gameModel.hasComponent(entity, "Owner")) {
      const ownerData = gameModel.getComponentUnsafe(entity, "Owner");
      if (ownerData.owner != void 0) {
        AttachData.parent = ownerData.owner;
      }
    }
  }
  run(entity, gameModel) {
    const AttachData = gameModel.getTypedUnsafe(entity, AttachSchema);
    if (AttachData.parent != void 0) {
      if (!gameModel.isActive(AttachData.parent)) {
        AttachData.parent = null;
        return;
      }
      if (!gameModel.hasComponent(AttachData.parent, "Attached")) {
        gameModel.addComponent(AttachData.parent, "Attached", {
          children: [entity]
        });
      } else {
        const parentData = gameModel.getTypedUnsafe(AttachData.parent, AttachedSchema);
        if (parentData.children.indexOf(entity) == -1) {
          parentData.children.push(entity);
        }
      }
      let transformSchema = gameModel.getTypedUnsafe(AttachData.parent, TransformSchema);
      const ownerPosition = transformSchema.position;
      transformSchema = gameModel.getTypedUnsafe(entity, TransformSchema);
      transformSchema.x = ownerPosition.x;
      transformSchema.y = ownerPosition.y;
      if (AttachData.offset) {
        transformSchema.x += AttachData.offset.x;
        transformSchema.y += AttachData.offset.y;
      }
      if (AttachData.direction && gameModel.hasComponent(entity, "Locomotion") && gameModel.hasComponent(AttachData.parent, "Locomotion")) {
        let locomotionSchema = gameModel.getTypedUnsafe(AttachData.parent, LocomotionSchema);
        const parentDirectionX = locomotionSchema.directionX;
        const parentDirectionY = locomotionSchema.directionY;
        locomotionSchema = gameModel.getTypedUnsafe(entity, LocomotionSchema);
        locomotionSchema.directionX = parentDirectionX;
        locomotionSchema.directionY = parentDirectionY;
      }
    }
  }
}
registerSystem(AttachSystem);
class AttachPostSystem {
  constructor() {
    __publicField(this, "type", "AttachPost");
    __publicField(this, "category", ComponentCategory.BEHAVIOR);
    __publicField(this, "depth", DEPTHS.PREDRAW - 10);
    __publicField(this, "schema", AttachPostSchema);
  }
  run(entity, gameModel) {
    const AttachData = gameModel.getTypedUnsafe(entity, AttachSchema);
    if (AttachData.parent != void 0) {
      if (!gameModel.isActive(AttachData.parent)) {
        AttachData.parent = null;
        return;
      }
      if (!gameModel.hasComponent(AttachData.parent, "Attached")) {
        gameModel.addComponent(AttachData.parent, "Attached", {
          children: [entity]
        });
      } else {
        const parentData = gameModel.getTypedUnsafe(AttachData.parent, AttachedSchema);
        if (parentData.children.indexOf(entity) == -1) {
          parentData.children.push(entity);
        }
      }
      if (AttachData.post) {
        let transformSchema = gameModel.getTypedUnsafe(AttachData.parent, TransformSchema);
        const ownerPosition = transformSchema.position;
        transformSchema = gameModel.getTypedUnsafe(entity, TransformSchema);
        transformSchema.x = ownerPosition.x;
        transformSchema.y = ownerPosition.y;
        if (AttachData.offset) {
          transformSchema.x += AttachData.offset.x;
          transformSchema.y += AttachData.offset.y;
        }
      }
    }
  }
}
registerSystem(AttachPostSystem);
export {
  AttachPostSchema
};
//# sourceMappingURL=Attach.js.map
